import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);

// Change colors here
const vuetify = new Vuetify({
    theme: {
      themes: {
        light: {
          primary: colors.orange,
          secondary: '#b0bec5',
          anchor: '#8c9eff',
          buttonSelected: '#28a745',
          buttonUnselected: '#c6e0cc',
          
        },
      },
    },
  })


export default vuetify